import http from "../http-common";
import authHeader from './auth-header';

class MaintenanceService {
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ACTIVATIONS

createActivation(data) {
    return http.post("/maintenance/activations/create", data, { headers: authHeader() });
  }

  getAllActivations() {
    return http.get("/maintenance/activations", { headers: authHeader() });
  }

  getActivation(ActivationID) {
    return http.get(`/maintenance/activations/${ActivationID}`, { headers: authHeader() });
  }

  updateActivation(ActivationID, data) {
    return http.put(`/maintenance/activations/update/${ActivationID}`, data, { headers: authHeader() });
  }

  deleteActivation(ActivationID) {
    return http.delete(`/maintenance/activations/delete/${ActivationID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BANK ACOOUNT TYPES

createBankAccountType(data) {
    return http.post("/maintenance/bank_account_types/create", data, { headers: authHeader() });
  }

  getAllBankAccountTypes() {
    return http.get("/maintenance/bank_account_types", { headers: authHeader() });
  }

  getBankAccountType(BankAccountTypeID) {
    return http.get(`/maintenance/bank_account_types/${BankAccountTypeID}`, { headers: authHeader() });
  }

  updateBankAccountType(BankAccountTypeID, data) {
    return http.put(`/maintenance/bank_account_types/update/${BankAccountTypeID}`, data, { headers: authHeader() });
  }

  deleteBankAccountType(BankAccountTypeID) {
    return http.delete(`/maintenance/bank_account_types/delete/${BankAccountTypeID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// OFFICES

createOffice(data) {
    return http.post("/maintenance/offices/create", data, { headers: authHeader() });
  }

  getAllOffices() {
    return http.get("/maintenance/offices", { headers: authHeader() });
  }

  getOffice(OfficeId) {
    return http.get(`/maintenance/offices/${OfficeId}`, { headers: authHeader() });
  }

  updateOffice(OfficeId, data) {
    return http.put(`/maintenance/offices/update/${OfficeId}`, data, { headers: authHeader() });
  }

  deleteOffice(OfficeId) {
    return http.delete(`/maintenance/offices/delete/${OfficeId}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// NMI REBATES

createNMIRebate(data) {
    return http.post("/maintenance/nmi_rebates/create", data, { headers: authHeader() });
  }

  getAllNMIRebates() {
    return http.get("/maintenance/nmi_rebates", { headers: authHeader() });
  }

  updateNMIRebate(NMIRebateRateID, data) {
    return http.put(`/maintenance/nmi_rebates/update/${NMIRebateRateID}`, data, { headers: authHeader() });
  }

  deleteNMIRebate(NMIRebateRateID) {
    return http.delete(`/maintenance/nmi_rebates/delete/${NMIRebateRateID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BANK BRANCHES

createBankBranch(data) {
    return http.post("/maintenance/banks/branches/create", data, { headers: authHeader() });
  }

  getAllBankBranches() {
    return http.get("/maintenance/banks/branches", { headers: authHeader() });
  }

  updateBankBranch(BranchID, data) {
    return http.put(`/maintenance/banks/branches/update/${BranchID}`, data, { headers: authHeader() });
  }

  deleteBankBranch(BranchID) {
    return http.delete(`/maintenance/banks/branches/delete/${BranchID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BANKS

createBank(data) {
    return http.post("/maintenance/banks/create", data, { headers: authHeader() });
  }

  getAllBanks() {
    return http.get("/maintenance/banks", { headers: authHeader() });
  }

  getBank(BankID) {
    return http.get(`/maintenance/banks/${BankID}`, { headers: authHeader() });
  }

  updateBank(BankID, data) {
    return http.put(`/maintenance/banks/update/${BankID}`, data, { headers: authHeader() });
  }

  deleteBank(BankID) {
    return http.delete(`/maintenance/banks/delete/${BankID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BOND INVESTMENT TYPES

createBondInvestmentType(data) {
    return http.post("/maintenance/bond_investment_types/create", data, { headers: authHeader() });
  }

  getAllBondInvestmentTypes() {
    return http.get("/maintenance/bond_investment_types", { headers: authHeader() });
  }

  getBondInvestmentType(BondInvestmentTypeID) {
    return http.get(`/maintenance/bond_investment_types/${BondInvestmentTypeID}`, { headers: authHeader() });
  }

  updateBondInvestmentType(BondInvestmentTypeID, data) {
    return http.put(`/maintenance/bond_investment_types/update/${BondInvestmentTypeID}`, data, { headers: authHeader() });
  }

  deleteBondInvestmentType(BondInvestmentTypeID) {
    return http.delete(`/maintenance/bond_investment_types/delete/${BondInvestmentTypeID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CALL ACCOUNT TYPES

createCallAccountType(data) {
    return http.post("/maintenance/call_account_types/create", data, { headers: authHeader() });
  }

  getAllCallAccountTypes() {
    return http.get("/maintenance/call_account_types", { headers: authHeader() });
  }

  getCallAccountType(CallAccountTypeID) {
    return http.get(`/maintenance/call_account_types/${CallAccountTypeID}`, { headers: authHeader() });
  }

  updateCallAccountType(CallAccountTypeID, data) {
    return http.put(`/maintenance/call_account_types/update/${CallAccountTypeID}`, data, { headers: authHeader() });
  }

  deleteCallAccountType(CallAccountTypeID) {
    return http.delete(`/maintenance/call_account_types/delete/${CallAccountTypeID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// COUNTRIES

createCountry(data) {
    return http.post("/maintenance/countries/create", data, { headers: authHeader() });
  }

  getAllCountries() {
    return http.get("/maintenance/countries", { headers: authHeader() });
  }

  getCountry(CountryId) {
    return http.get(`/maintenance/countries/${CountryId}`, { headers: authHeader() });
  }

  updateCountry(CountryId, data) {
    return http.put(`/maintenance/countries/update/${CountryId}`, data, { headers: authHeader() });
  }

  deleteCountry(CountryId) {
    return http.delete(`/maintenance/countries/delete/${CountryId}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CITIES

createCity(data) {
    return http.post("/maintenance/cities/create", data, { headers: authHeader() });
  }

  getAllCities() {
    return http.get("/maintenance/cities", { headers: authHeader() });
  }

  getCity(CityID) {
    return http.get(`/maintenance/cities/${CityID}`, { headers: authHeader() });
  }

  updateCity(CityID, data) {
    return http.put(`/maintenance/cities/update/${CityID}`, data, { headers: authHeader() });
  }

  deleteCity(CityID) {
    return http.delete(`/maintenance/cities/delete/${CityID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CLIENT TYPES

createClientType(data) {
    return http.post("/maintenance/client_types/create", data, { headers: authHeader() });
  }

  getAllClientTypes() {
    return http.get("/maintenance/client_types", { headers: authHeader() });
  }

  getClientType(ClientTypeID) {
    return http.get(`/maintenance/client_types/${ClientTypeID}`, { headers: authHeader() });
  }

  updateClientType(ClientTypeID, data) {
    return http.put(`/maintenance/client_types/update/${ClientTypeID}`, data, { headers: authHeader() });
  }

  deleteClientType(ClientTypeID) {
    return http.delete(`/maintenance/client_types/delete/${ClientTypeID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CURRENCIES

createCurrency(data) {
    return http.post("/maintenance/currencies/create", data, { headers: authHeader() });
  }

  getAllCurrencies() {
    return http.get("/maintenance/currencies", { headers: authHeader() });
  }

  getCurrency(CurrencyID) {
    return http.get(`/maintenance/currencies/${CurrencyID}`, { headers: authHeader() });
  }

  updateCurrency(CurrencyID, data) {
    return http.put(`/maintenance/currencies/update/${CurrencyID}`, data, { headers: authHeader() });
  }

  deleteCurrency(CurrencyID) {
    return http.delete(`/maintenance/currencies/delete/${CurrencyID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DEALER GROUPS

createDealerGroup(data) {
    return http.post("/maintenance/dealer_groups/create", data, { headers: authHeader() });
  }

  getAllDealerGroups() {
    return http.get("/maintenance/dealer_groups", { headers: authHeader() });
  }

  getDealerGroup(DealerGroupID) {
    return http.get(`/maintenance/dealer_groups/${DealerGroupID}`, { headers: authHeader() });
  }

  updateDealerGroup(DealerGroupID, data) {
    return http.put(`/maintenance/dealer_groups/update/${DealerGroupID}`, data, { headers: authHeader() });
  }

  deleteDealerGroup(DealerGroupID) {
    return http.delete(`/maintenance/dealer_groups/delete/${DealerGroupID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DELIVERY METHODS

createDeliveryMethod(data) {
    return http.post("/maintenance/delivery_methods/create", data, { headers: authHeader() });
  }

  getAllDeliveryMethods() {
    return http.get("/maintenance/delivery_methods", { headers: authHeader() });
  }

  getDeliveryMethod(DeliveryMethodID) {
    return http.get(`/maintenance/delivery_methods/${DeliveryMethodID}`, { headers: authHeader() });
  }

  updateDeliveryMethod(DeliveryMethodID, data) {
    return http.put(`/maintenance/delivery_methods/update/${DeliveryMethodID}`, data, { headers: authHeader() });
  }

  deleteDeliveryMethod(DeliveryMethodID) {
    return http.delete(`/maintenance/delivery_methods/delete/${DeliveryMethodID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DEPOSIT METHODS

createDepositMethod(data) {
    return http.post("/maintenance/deposit_methods/create", data, { headers: authHeader() });
  }

  getAllDepositMethods() {
    return http.get("/maintenance/deposit_methods", { headers: authHeader() });
  }

  getDepositMethod(DepositMethodID) {
    return http.get(`/maintenance/deposit_methods/${DepositMethodID}`, { headers: authHeader() });
  }

  updateDepositMethod(DepositMethodID, data) {
    return http.put(`/maintenance/deposit_methods/update/${DepositMethodID}`, data, { headers: authHeader() });
  }

  deleteDepositMethod(DepositMethodID) {
    return http.delete(`/maintenance/deposit_methods/delete/${DepositMethodID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// FINANCIAL YEARS

createFinancialYear(data) {
    return http.post("/maintenance/financial_years/create", data, { headers: authHeader() });
  }

  getAllFinancialYears() {
    return http.get("/maintenance/financial_years", { headers: authHeader() });
  }

  getFinancialYear(FinancialYearID) {
    return http.get(`/maintenance/financial_years/${FinancialYearID}`, { headers: authHeader() });
  }

  updateFinancialYear(FinancialYearID, data) {
    return http.put(`/maintenance/financial_years/update/${FinancialYearID}`, data, { headers: authHeader() });
  }

  deleteFinancialYear(FinancialYearID) {
    return http.delete(`/maintenance/financial_years/delete/${FinancialYearID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// FREQUENCIES

createFrequency(data) {
    return http.post("/maintenance/frequencies/create", data, { headers: authHeader() });
  }

  getAllFrequencies() {
    return http.get("/maintenance/frequencies", { headers: authHeader() });
  }

  getFrequency(FrequencyID) {
    return http.get(`/maintenance/frequencies/${FrequencyID}`, { headers: authHeader() });
  }

  updateFrequency(FrequencyID, data) {
    return http.put(`/maintenance/frequencies/update/${FrequencyID}`, data, { headers: authHeader() });
  }

  deleteFrequency(FrequencyID) {
    return http.delete(`/maintenance/frequencies/delete/${FrequencyID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// HOLIDAYS

createHoliday(data) {
    return http.post("/maintenance/holidays/create", data, { headers: authHeader() });
  }

  getAllHolidays() {
    return http.get("/maintenance/holidays", { headers: authHeader() });
  }

  getHoliday(HolidayID) {
    return http.get(`/maintenance/holidays/${HolidayID}`, { headers: authHeader() });
  }

  updateHoliday(HolidayID, data) {
    return http.put(`/maintenance/holidays/update/${HolidayID}`, data, { headers: authHeader() });
  }

  deleteHoliday(HolidayID) {
    return http.delete(`/maintenance/holidays/delete/${HolidayID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IDENTITY TYPES

createIdentityType(data) {
    return http.post("/maintenance/identity_types/create", data, { headers: authHeader() });
  }

  getAllIdentityTypes() {
    return http.get("/maintenance/identity_types", { headers: authHeader() });
  }

  getIdentityType(IdentityTypeID) {
    return http.get(`/maintenance/identity_types/${IdentityTypeID}`, { headers: authHeader() });
  }

  updateIdentityType(IdentityTypeID, data) {
    return http.put(`/maintenance/identity_types/update/${IdentityTypeID}`, data, { headers: authHeader() });
  }

  deleteIdentityType(IdentityTypeID) {
    return http.delete(`/maintenance/identity_types/delete/${IdentityTypeID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// OVERRIDE REASONS

createOverrideReason(data) {
    return http.post("/maintenance/override_reasons/create", data, { headers: authHeader() });
  }

  getAllOverrideReasons() {
    return http.get("/maintenance/override_reasons", { headers: authHeader() });
  }

  getOverrideReason(OverrideReasonID) {
    return http.get(`/maintenance/override_reasons/${OverrideReasonID}`, { headers: authHeader() });
  }

  updateOverrideReason(OverrideReasonID, data) {
    return http.put(`/maintenance/override_reasons/update/${OverrideReasonID}`, data, { headers: authHeader() });
  }

  deleteOverrideReason(OverrideReasonID) {
    return http.delete(`/maintenance/override_reasons/delete/${OverrideReasonID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PROPERTY TYPES

createPropertyType(data) {
    return http.post("/maintenance/property_types/create", data, { headers: authHeader() });
  }

  getAllPropertyTypes() {
    return http.get("/maintenance/property_types", { headers: authHeader() });
  }

  getPropertyType(PropertyTypeID) {
    return http.get(`/maintenance/property_types/${PropertyTypeID}`, { headers: authHeader() });
  }

  updatePropertyType(PropertyTypeID, data) {
    return http.put(`/maintenance/property_types/update/${PropertyTypeID}`, data, { headers: authHeader() });
  }

  deletePropertyType(PropertyTypeID) {
    return http.delete(`/maintenance/property_types/delete/${PropertyTypeID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// REJECTION REASONS

createRejectionReason(data) {
    return http.post("/maintenance/rejection_reasons/create", data, { headers: authHeader() });
  }

  getAllRejectionReasons() {
    return http.get("/maintenance/rejection_reasons", { headers: authHeader() });
  }

  getRejectionReason(RejectionReasonID) {
    return http.get(`/maintenance/rejection_reasons/${RejectionReasonID}`, { headers: authHeader() });
  }

  updateRejectionReason(RejectionReasonID, data) {
    return http.put(`/maintenance/rejection_reasons/update/${RejectionReasonID}`, data, { headers: authHeader() });
  }

  deleteRejectionReason(RejectionReasonID) {
    return http.delete(`/maintenance/rejection_reasons/delete/${RejectionReasonID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SECTORS

createSector(data) {
    return http.post("/maintenance/sectors/create", data, { headers: authHeader() });
  }

  getAllSectors() {
    return http.get("/maintenance/sectors", { headers: authHeader() });
  }

  getSector(SectorID) {
    return http.get(`/maintenance/sectors/${SectorID}`, { headers: authHeader() });
  }

  updateSector(SectorID, data) {
    return http.put(`/maintenance/sectors/update/${SectorID}`, data, { headers: authHeader() });
  }

  deleteSector(SectorID) {
    return http.delete(`/maintenance/sectors/delete/${SectorID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ACCOUNT STATUSES

createAccountStatus(data) {
    return http.post("/maintenance/account_status/create", data, { headers: authHeader() });
  }

  getAllAccountStatuses() {
    return http.get("/maintenance/account_status", { headers: authHeader() });
  }

  getAccountStatus(AccountStatusID) {
    return http.get(`/maintenance/account_status/${AccountStatusID}`, { headers: authHeader() });
  }

  updateAccountStatus(AccountStatusID, data) {
    return http.put(`/maintenance/account_status/update/${AccountStatusID}`, data, { headers: authHeader() });
  }

  deleteAccountStatus(AccountStatusID) {
    return http.delete(`/maintenance/account_status/delete/${AccountStatusID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CUSTODIAN STATUSES

createCustodianStatus(data) {
    return http.post("/maintenance/custodian_status/create", data, { headers: authHeader() });
  }

  getAllCustodianStatuses() {
    return http.get("/maintenance/custodian_status", { headers: authHeader() });
  }

  getCustodianStatus(CustodianStatusID) {
    return http.get(`/maintenance/custodian_status/${CustodianStatusID}`, { headers: authHeader() });
  }

  updateCustodianStatus(CustodianStatusID, data) {
    return http.put(`/maintenance/custodian_status/update/${CustodianStatusID}`, data, { headers: authHeader() });
  }

  deleteCustodianStatus(CustodianStatusID) {
    return http.delete(`/maintenance/custodian_status/delete/${CustodianStatusID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PROPERTY STATUSES

createPropertyStatus(data) {
    return http.post("/maintenance/property_status/create", data, { headers: authHeader() });
  }

  getAllPropertyStatuses() {
    return http.get("/maintenance/property_status", { headers: authHeader() });
  }

  getPropertyStatus(PropertyStatusID) {
    return http.get(`/maintenance/property_status/${PropertyStatusID}`, { headers: authHeader() });
  }

  updatePropertyStatus(PropertyStatusID, data) {
    return http.put(`/maintenance/property_status/update/${PropertyStatusID}`, data, { headers: authHeader() });
  }

  deletePropertyStatus(PropertyStatusID) {
    return http.delete(`/maintenance/property_status/delete/${PropertyStatusID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// EXCHANGE PAIRS

createExchangePair(data) {
    return http.post("/maintenance/exchange_pairs/create", data, { headers: authHeader() });
  }

  getAllExchangePairs() {
    return http.get("/maintenance/exchange_pairs", { headers: authHeader() });
  }

  getExchangePair(ExchangeID) {
    return http.get(`/maintenance/exchange_pairs/${ExchangeID}`, { headers: authHeader() });
  }

  updateExchangePair(ExchangeID, data) {
    return http.put(`/maintenance/exchange_pairs/update/${ExchangeID}`, data, { headers: authHeader() });
  }

  deleteExchangePair(ExchangeID) {
    return http.delete(`/maintenance/exchange_pairs/delete/${ExchangeID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TITLES

createTitle(data) {
    return http.post("/maintenance/titles/create", data, { headers: authHeader() });
  }

  getAllTitles() {
    return http.get("/maintenance/titles", { headers: authHeader() });
  }

  getTitle(TitleID) {
    return http.get(`/maintenance/titles/${TitleID}`, { headers: authHeader() });
  }

  updateTitle(TitleID, data) {
    return http.put(`/maintenance/titles/update/${TitleID}`, data, { headers: authHeader() });
  }

  deleteTitle(TitleID) {
    return http.delete(`/maintenance/titles/delete/${TitleID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TRANSACTION CODES

createTransactionCode(data) {
    return http.post("/maintenance/transaction_codes/create", data, { headers: authHeader() });
  }

  getAllTransactionCodes() {
    return http.get("/maintenance/transaction_codes", { headers: authHeader() });
  }

  getTransactionCode(TransactionCodeID) {
    return http.get(`/maintenance/transaction_codes/${TransactionCodeID}`, { headers: authHeader() });
  }

  updateTransactionCode(TransactionCodeID, data) {
    return http.put(`/maintenance/transaction_codes/update/${TransactionCodeID}`, data, { headers: authHeader() });
  }

  deleteTransactionCode(TransactionCodeID) {
    return http.delete(`/maintenance/transaction_codes/delete/${TransactionCodeID}`, { headers: authHeader() });
  }
}

export default new MaintenanceService();